export const TOKEN = 'TOKEN'
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
